import { useState, useEffect } from "react";
import ModalFrame from "../../components/modal/ModalFrame";
import { Dialog } from "@headlessui/react";
import * as api from "./apiService";

const JobInspectionChecklistModal = ({
  isOpen,
  handleClose,
  inspectionType,
}) => {
  const [globalInspectionChecklist, setGlobalInspectionChecklist] = useState(
    []
  );

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.getGlobalInspectionChecklist({
          inspection_type: inspectionType,
        });
        const items = data.results
          .flatMap((item) => (item.item_description || "").split(/\r?\n/))
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
        setGlobalInspectionChecklist(items);
      } catch {
        alert("Unable to fetch global inspection checklist.");
      }
    })();
  }, []);

  return (
    <ModalFrame isModalOpen={isOpen}>
      <div className="px-6 pt-5 pb-4">
        <Dialog.Title
          as="h3"
          className="text-2xl font-semibold text-gray-900 text-center"
        >
          {inspectionType === "I" ? "Initial" : "Final"} Job Inspection
          Checklist
        </Dialog.Title>

        {/* Acknowledgment */}
        <div className="mt-5 rounded-lg border border-gray-200 bg-white">
          <div className="px-4 py-3 border-b border-gray-200">
            <h4 className="text-sm font-semibold tracking-wide text-gray-700 uppercase">
              Acknowledgment
            </h4>
          </div>
          <div className="px-4 py-4 text-gray-700 text-sm">
            <p>
              List of items to review during the job inspection. Please ensure
              that all items are checked and acknowledged before proceeding with
              the job.
            </p>
            <p>
              This checklist is designed to help maintain quality and safety
              standards throughout the job process.
            </p>
          </div>
        </div>

        <div className="mt-4 rounded-lg border border-gray-200 bg-white">
          <div id="inspection-checklist" className="px-4 pt-2 pb-4">
            <div className="max-h-56 overflow-y-auto pr-1">
              {globalInspectionChecklist.length === 0 ? (
                <div className="text-sm text-gray-500">No items found.</div>
              ) : (
                <ul className="list-none pl-1 space-y-2 text-gray-700">
                  {globalInspectionChecklist.map((item, idx) => (
                    <li key={idx} className="text-sm leading-6">
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        {/* Footer buttons (stacked) */}
        <div className="mt-6 grid grid-cols-1 gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="inline-flex w-full items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-sky-500"
          >
            Close
          </button>
        </div>
      </div>
    </ModalFrame>
  );
};

export default JobInspectionChecklistModal;
